// Default dimensions for A4 Landscape in pixels at 72 DPI (Standard screen resolution)
export const A4_LANDSCAPE_WIDTH = 842;
export const A4_LANDSCAPE_HEIGHT = 595;

/**
 * Returns a blank canvas JSON structure containing a baseline geometric border decoration.
 */
export function getBlankCertificateJson(): string {
  const data = {
    version: "7.4.0",
    objects: [
      // Double outer borders
      {
        type: "rect",
        version: "7.4.0",
        left: 15,
        top: 15,
        width: A4_LANDSCAPE_WIDTH - 30,
        height: A4_LANDSCAPE_HEIGHT - 30,
        fill: "transparent",
        stroke: "#1e3a8a",
        strokeWidth: 6,
        selectable: true,
      },
      {
        type: "rect",
        version: "7.4.0",
        left: 23,
        top: 23,
        width: A4_LANDSCAPE_WIDTH - 46,
        height: A4_LANDSCAPE_HEIGHT - 46,
        fill: "transparent",
        stroke: "#d97706",
        strokeWidth: 2,
        selectable: true,
      },
    ],
  };
  return JSON.stringify(data);
}

/**
 * Returns a fully pre-styled, elegant Certificate of Appreciation template JSON structure
 * featuring dynamic merge tokens, signature lines, gold seal ornaments, and headings.
 */
export function getDemoCertificateJson(): string {
  const data = {
    version: "7.4.0",
    objects: [
      // Outer Border (Blue)
      {
        type: "rect",
        version: "7.4.0",
        left: 15,
        top: 15,
        width: A4_LANDSCAPE_WIDTH - 30,
        height: A4_LANDSCAPE_HEIGHT - 30,
        fill: "transparent",
        stroke: "#1e3a8a",
        strokeWidth: 6,
        selectable: true,
      },
      // Inner Border (Gold)
      {
        type: "rect",
        version: "7.4.0",
        left: 23,
        top: 23,
        width: A4_LANDSCAPE_WIDTH - 46,
        height: A4_LANDSCAPE_HEIGHT - 46,
        fill: "transparent",
        stroke: "#d97706",
        strokeWidth: 2,
        selectable: true,
      },
      // Header: Certificate Title
      {
        type: "i-text",
        version: "7.4.0",
        left: A4_LANDSCAPE_WIDTH / 2 - 250,
        top: 60,
        width: 500,
        text: "CERTIFICATE OF ACHIEVEMENT",
        fontSize: 32,
        fontFamily: "Georgia",
        fontWeight: "bold",
        fill: "#1e3a8a",
        textAlign: "center",
      },
      // Subtitle
      {
        type: "i-text",
        version: "7.4.0",
        left: A4_LANDSCAPE_WIDTH / 2 - 150,
        top: 110,
        width: 300,
        text: "PROUDLY PRESENTED TO",
        fontSize: 14,
        fontFamily: "Inter",
        fontWeight: "bold",
        fill: "#b45309",
        textAlign: "center",
      },
      // Divider line
      {
        type: "line",
        version: "7.4.0",
        x1: A4_LANDSCAPE_WIDTH / 2 - 180,
        y1: 135,
        x2: A4_LANDSCAPE_WIDTH / 2 + 180,
        y2: 135,
        stroke: "#d97706",
        strokeWidth: 2,
      },
      // Student Name dynamic token (Merge Field)
      {
        type: "i-text",
        version: "7.4.0",
        left: A4_LANDSCAPE_WIDTH / 2 - 200,
        top: 180,
        width: 400,
        text: "{{student_name}}",
        fontSize: 38,
        fontFamily: "Playfair Display",
        fontWeight: "bold",
        fill: "#1e293b",
        textAlign: "center",
      },
      // Description Paragraph
      {
        type: "textbox",
        version: "7.4.0",
        left: A4_LANDSCAPE_WIDTH / 2 - 260,
        top: 260,
        width: 520,
        text: "For demonstrating outstanding academic performance, excellent conduct, and exemplary dedication to learning in class {{class_name}} during the academic session year {{session_name}}.",
        fontSize: 16,
        fontFamily: "Inter",
        fill: "#475569",
        textAlign: "center",
        lineHeight: 1.5,
      },
      // Gold circular seal outline
      {
        type: "circle",
        version: "7.4.0",
        left: A4_LANDSCAPE_WIDTH / 2 - 35,
        top: 380,
        radius: 35,
        fill: "transparent",
        stroke: "#d97706",
        strokeWidth: 3,
        selectable: true,
      },
      {
        type: "i-text",
        version: "7.4.0",
        left: A4_LANDSCAPE_WIDTH / 2 - 25,
        top: 405,
        width: 50,
        text: "SEAL",
        fontSize: 12,
        fontFamily: "Inter",
        fontWeight: "bold",
        fill: "#d97706",
        textAlign: "center",
      },
      // Left Signature Line
      {
        type: "line",
        version: "7.4.0",
        x1: 80,
        y1: 460,
        x2: 240,
        y2: 460,
        stroke: "#475569",
        strokeWidth: 1.5,
      },
      {
        type: "i-text",
        version: "7.4.0",
        left: 80,
        top: 470,
        width: 160,
        text: "Principal Signature",
        fontSize: 13,
        fontFamily: "Inter",
        fill: "#475569",
        textAlign: "center",
      },
      // Right Signature Line
      {
        type: "line",
        version: "7.4.0",
        x1: A4_LANDSCAPE_WIDTH - 240,
        y1: 460,
        x2: A4_LANDSCAPE_WIDTH - 80,
        y2: 460,
        stroke: "#475569",
        strokeWidth: 1.5,
      },
      {
        type: "i-text",
        version: "7.4.0",
        left: A4_LANDSCAPE_WIDTH - 240,
        top: 470,
        width: 160,
        text: "Class Teacher",
        fontSize: 13,
        fontFamily: "Inter",
        fill: "#475569",
        textAlign: "center",
      },
    ],
  };
  return JSON.stringify(data);
}
